import { createContext } from 'react';
var TableContext = /*#__PURE__*/createContext({
  columns: [],
  dataSource: [],
  rowKey: 'key'
});
export default TableContext;